const B2B_V2 = true

const invoiceTypes = ['增值税普通电子发票（单位）', '增值税普通电子发票（个人）']
const APP_CODE = 'zgcz'
const TIP_SHOW = true
// const invoiceTypes = ['普通电子发票（单位）', '普通电子发票（个人）', '增值税专用发票']
const title = '中国财政杂志社“三刊两鉴”在线征订系统'
const copyright = '中国财政杂志社 版权所有'
const icp = '京ICP备19047955号'
const ISSUE_RANGE = false
const accountInfo = {
  name: '中国财政杂志社',
  bank: '中国工商银行北京市公主坟支行',
  account: '0200004609089129195',
  bankNum: '',
  address: ''
}
const payWay = [
  'upload',
  'invoice'
]
const ORDER_STATE = [
  {
    label: '全部',
    state: '-1'
  },
  {
    label: '未支付',
    state: 'PN'
  },
  {
    label: '已支付',
    state: 'P1'
  },
  {
    label: '凭证审核中',
    state: 'P2'
  },
  {
    label: '提前开票审核中',
    state: 'A2'
  },
  {
    label: '未开票',
    state: 'IN'
  },
  {
    label: '已开票',
    state: 'I1'
  },
  {
    label: '订单已取消',
    state: 'I9'
  }
]
const invoiceEnable = function (order) {
  return order.subCategory !== '个人'
}

export default {
  ISSUE_RANGE: ISSUE_RANGE,
  invoiceTypes: invoiceTypes,
  title: title,
  icp: icp,
  APP_CODE: APP_CODE,
  copyright: copyright,
  accountInfo: accountInfo,
  payWay: payWay,
  ORDER_STATE: ORDER_STATE,
  invoiceEnable: invoiceEnable,
  TIP_SHOW: TIP_SHOW,
  B2B_V2: B2B_V2,
  org: {
    enabled: false,
    label: '归属地区'
  },
  invoice: {
    disabledAfter: 90 * 86400 * 1000,
    disabledAfterDesc: '订单支付超过3个月，如果未开票，订单点击开票时，弹框提示：“请您务必在消费三个月内开具电子发票，逾期请致电13120109271开票',
    requestAfterReverse: false,
    taxNumRequired: true,
    splitInvoice: true,
    withInvoiceInfo: true
  },
  footer: {
    customPhone: '',
    adLine: '',
    bookLine: '征订联系电话：010-68222816、68270294 传真:010-68221432。工作时间:早8:30-晚5:00。',
    afterSalePhone: ''
  },
  popInfo: false,
  labelInfos: {
    payButton: '去开票',
    payNextButton: '继续去开票',
    orgLabelType1: '归属地区',
    orgLabelType2: '归属地区',
    orgLabelType1Msg: '请选择归属地区',
    orgLabelType2Msg: '请选择归属地区'
  }
}
